import { render, staticRenderFns } from "./GoogleCv.vue?vue&type=template&id=5bc64bbf&scoped=true&"
import script from "./GoogleCv.vue?vue&type=script&lang=js&"
export * from "./GoogleCv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc64bbf",
  null
  
)

export default component.exports